import AbstractCommand from '../AbstractCommand';
import companyBrands from '../../requests/brands/companyBrands';

/**
 *
 */
export default class GetCompanyBrandsCommand extends AbstractCommand {
	constructor(companyId) {
		super();
		this.companyId = companyId;
	}

	/**
	 *
	 * @param successCallback
	 * @param failCallback
	 */
	execute(successCallback, failCallback) {
		companyBrands(this.companyId)
			.then((response) => {
				successCallback(response);
			})
			.catch((err) => {
				if (failCallback) {
					failCallback(err);
				}
			});
	}
}
